module.exports = __webpack_public_path__ + "img/vatican-city.6b67bc45.svg";